
import { useQuery } from 'react-query';
import { setHeaders } from '../../../utils/basic';
import * as config from '../../../app.config';
import axios from 'axios';


const getQlpFiles = async () => {
    try {
        const headerConfig = setHeaders();
        const { data } = await axios.get(
            `${config.ENDPOINTS["datalake"]}/list/qlp`,
            { headers: headerConfig }
        );
        const dateSortedData = data?.data;
        // Sort the files by ingest_date (descending)
        dateSortedData.sort((a, b) => {
            const dateA = new Date(Date.parse(a?.ingest_date));
            const dateB = new Date(Date.parse(b?.ingest_date));
            return dateB - dateA;
        });
        return dateSortedData;
    } catch (error) {
        // Handle the error (log, display message, etc.)
        throw error;
    }
};


export const useFetchQlpFiles = () => {
    return useQuery('QlpFiles', getQlpFiles, {
        onError: (error) => {
            // Handle the error  (display error message, etc.)
            console.error("Error in useQuery:", error);
        }
    });
};

